import { Suspense, lazy } from 'react';
import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Lazy-loaded components with webpackChunkName "onboarding-portal-app"
export const OnboardingLayout = Loader(
  lazy(
    () =>
      import(
        /* webpackChunkName: "onboarding-portal-app" */ './OnboardingLayout'
      )
  )
);

export const OnboardingLoginPage = Loader(
  lazy(
    () =>
      import(
        /* webpackChunkName: "onboarding-portal-app" */ './Auth/OnboardingLoginPage'
      )
  )
);

export const OnboardingDashboard = Loader(
  lazy(
    () =>
      import(
        /* webpackChunkName: "onboarding-portal-app" */ './Dashboard/OnboardingDashboard'
      )
  )
);

export const StepRouter = Loader(
  lazy(
    () =>
      import(
        /* webpackChunkName: "onboarding-portal-app" */ './Steps/StepRouter'
      )
  )
);

export const ReviewSubmitStep = Loader(
  lazy(
    () =>
      import(
        /* webpackChunkName: "onboarding-portal-app" */ './Steps/ReviewSubmitStep'
      )
  )
);

// Route configuration
const onboardingRoutes = {
  path: 'onboarding',
  children: [
    {
      // Login page - no layout wrapper (uses BaseLayout from parent)
      path: 'login',
      element: <OnboardingLoginPage />
    },
    {
      // All authenticated onboarding routes wrapped in OnboardingLayout
      path: '',
      element: <OnboardingLayout />,
      children: [
        { path: '', element: <OnboardingDashboard /> },
        { path: 'dashboard', element: <OnboardingDashboard /> },
        { path: 'step/:stepKey', element: <StepRouter /> },
        { path: 'review', element: <ReviewSubmitStep /> }
      ]
    }
  ]
};

export default onboardingRoutes;
